import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../../../../../service";
import { IErrorResponse } from "../../../../../../types";
import { IScientificTitleCreate, IScientificTitlePayload } from "../types";
import {
    deletedRestoreScientificTitle,
    deletedScientificTitle,
    setScientificTitle,
    setScientificTitleRestoreData,
    updateScientificTitle,
} from "./scientificTitleSlice";

const SetScientificTitle = createAsyncThunk(
    "create/scientific/title",
    async (data: IScientificTitleCreate, { rejectWithValue }) => {
        try {
            const response = await request.post("/scientific-titles", data);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetScientificTitles = createAsyncThunk("get/scientific/titles", async (_, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.get("/scientific-titles");

        dispatch(setScientificTitle({ data: response.data }));

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;

        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const DeleteScientificTitle = createAsyncThunk(
    "delete/scientific/title",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.delete(`/scientific-titles/${id}`);

            dispatch(deletedScientificTitle(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const EditScientificTitle = createAsyncThunk(
    "edit/scientific/title",
    async (data: IScientificTitlePayload, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/scientific-titles/${data.id}`, data);
            dispatch(updateScientificTitle(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetDeleteScientificTitle = createAsyncThunk("get/delete/titles", async (_, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.get(`/scientific-titles/deleted-items`);

        dispatch(setScientificTitleRestoreData(response.data));

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const RestoreDeleteScientificTitle = createAsyncThunk(
    "restore/delete/titles",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.post(`/scientific-titles/${id}/restore`);

            dispatch(deletedRestoreScientificTitle(id));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

export {
    GetScientificTitles,
    DeleteScientificTitle,
    EditScientificTitle,
    SetScientificTitle,
    GetDeleteScientificTitle,
    RestoreDeleteScientificTitle,
};
